import React from 'react';
import { Flex, Text } from 'rebass';
import stubAgencyName from '../../lib/stubAgencyName';
import {
  space,
  shadows,
  colors,
  fonts,
  fontSizes,
  fontWeights,
  letterSpacings,
  lineHeights,
} from '../../theme';
import { VerticalDivider } from '../styled/presentation';
import { ReactComponent as DCYFLogo } from '../../icons/dcyf-logo-wide.svg';

const logoHeight = 24;

const topBarTextStyles = {
  color: colors.deepTeal,
  fontFamily: fonts.secondary,
  fontWeight: fontWeights.bold,
  fontSize: fontSizes.large,
  lineHeight: lineHeights.medium,
  ml: 22,
  mr: space.one,
  letterSpacing: letterSpacings.small,
};

const AgencyName: React.FC = () => (
  <Text as="span" sx={topBarTextStyles}>
    {stubAgencyName}
  </Text>
);

export const TopBar: React.FC = () => (
  <Flex
    as="header"
    backgroundColor={colors.softTeal}
    justifyContent="space-between"
    sx={{
      position: 'relative',
      zIndex: 3,
      boxShadow: shadows.topBar,
    }}
  >
    <Flex
      alignItems="center"
      py={space.one}
      sx={{
        'hr, svg': {
          marginRight: '14px',
        },
        svg: {
          height: logoHeight,
        },
      }}
    >
      <AgencyName />
      <VerticalDivider
        styles={{ height: logoHeight, backgroundColor: colors.deepTeal }}
      />
      <DCYFLogo />
    </Flex>
  </Flex>
);
